export default {
    RELEASE_AUTOMATICALLY : 1,
    WITH_CONFIRM_MAILINGBOSS: 2,
    MANUAL_PAYMENT: 3,
    ACCESS_BY_BA_CREDENTIALS: 4,
    ACCESS_BY_BA_CREDENTIALS_PREMIUM: 5
}